<template>
  <div class="rw-detail pa-0">
    <div class="rw-box-card-list mr-1">
      <v-row class="rw-list pl-3 pr-2 pb-2">
        <v-card class="com-pc-card rw-info">
          <v-row class="com-pc-card-header rw-header pb-0 mb-0">
            <span v-if="selectedWarnType === 10" class="com-pc-card-title"
              >洪水予報</span
            >
            <span v-if="selectedWarnType === 11" class="com-pc-card-title"
              >水位到達情報</span
            >
            <span v-if="selectedWarnType === 20" class="com-pc-card-title"
              >水防警報</span
            >
            <span v-if="selectedWarnType === 30" class="com-pc-card-title"
              >ダム放流通知</span
            >
            <v-spacer></v-spacer>
            <v-btn
              v-if="
                this.selectedRwDetailMt.inundation &&
                  this.selectedRwDetailMt.inundation.inundationId
              "
              class="mr-2 mt-0"
              :class="{ 'white--text': !isDisp, 'success--text': isDisp }"
              :outlined="!isDisp"
              x-small
              color="white"
              @click="isDisp = !isDisp"
              ><span>{{ text.dispIu }}</span></v-btn
            >
            <v-btn
              class="mr-2 mt-0"
              v-if="
                selectedRwDetailRwFlg &&
                  selectedWarnType === 10 &&
                  selectedRwDetailRw.attchFlg === 1
              "
              outlined
              x-small
              color="white"
              @click="
                openPdf(
                  selectedRwDetailMt.fldfrCd,
                  'fldfr',
                  selectedRwDetailRw.annNo,
                  selectedRwDetailRw.annTime,
                  selectedRwDetailRw.docType,
                  selectedRwDetailRw.fldfrId
                )
              "
            >
              <span>洪水予報の本文</span>
            </v-btn>
            <v-btn
              class="mr-2 mt-0"
              v-if="
                selectedRwDetailRwFlg &&
                  selectedWarnType === 11 &&
                  selectedRwDetailRw.attchFlg === 1
              "
              outlined
              x-small
              color="white"
              @click="
                openPdf(
                  selectedRwDetailMt.evstgCd,
                  'evstg',
                  selectedRwDetailRw.annNo,
                  selectedRwDetailRw.annTime,
                  selectedRwDetailRw.docType,
                  selectedRwDetailRw.evstgId
                )
              "
            >
              <span>水位到達情報の本文</span>
            </v-btn>
            <v-btn
              class="mr-2 mt-0"
              v-if="
                selectedRwDetailRwFlg &&
                  selectedWarnType === 20 &&
                  selectedRwDetailRw.attchFlg === 1
              "
              outlined
              x-small
              color="white"
              @click="
                openPdf(
                  selectedRwDetailMt.fldctlCd,
                  'fldctl',
                  selectedRwDetailRw.annNo,
                  selectedRwDetailRw.annTime,
                  selectedRwDetailRw.docType,
                  selectedRwDetailRw.fldctlId
                )
              "
            >
              <span>水防警報の本文</span>
            </v-btn>
            <v-btn
              class="mr-2 mt-0"
              v-if="
                selectedRwDetailRwFlg &&
                  selectedWarnType === 30 &&
                  selectedRwDetailRw.attchFlg === 1
              "
              outlined
              x-small
              color="white"
              @click="
                openPdf(
                  selectedRwDetailMt.damdschCd,
                  'damdsch',
                  selectedRwDetailRw.annNo,
                  selectedRwDetailRw.annTime,
                  selectedRwDetailRw.docType,
                  selectedRwDetailRw.damdschId
                )
              "
            >
              <span>ダム放流通知文等の本文</span>
            </v-btn>
          </v-row>
          <rw-info></rw-info>
        </v-card>
        <v-card class="com-pc-card rw-info">
          <v-col class="com-pc-card-header rw-header">
            <span class="com-pc-card-title">関連情報</span>
            <!-- 凡例 -->
            <v-tooltip
              v-if="
                selectedWarnType === 10 ||
                  selectedWarnType === 11 ||
                  selectedWarnType === 20
              "
              bottom
              class="rw-tab-guide-tip"
              max-width="350"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="white" class="ml-1 pb-4"
                  >help_outline</v-icon
                >
              </template>
              <span>
                <span>
                  {{ config.messageConfig.legendMsg.tmStg.tmStgMsg1 }}
                  <br />
                  {{ config.messageConfig.legendMsg.tmStg.tmStgMsg2 }}
                  <br />
                </span>
                <span class="text-flood-occurrence rw-status-legend mb-1">
                  {{ config.messageConfig.legendMsg.tmStg.occurrence }}
                </span>
                <br />
                <span class="text-flood-danger rw-status-legend mb-1">
                  {{ config.messageConfig.legendMsg.tmStg.danger }}</span
                >
                <br />
                <span class="text-flood-refuge rw-status-legend mb-1">
                  {{ config.messageConfig.legendMsg.tmStg.refuge }}
                </span>
                <br />
                <span class="text-flood-warn rw-status-legend mb-1">
                  {{ config.messageConfig.legendMsg.tmStg.warn }}
                </span>
              </span>
            </v-tooltip>
          </v-col>
          <rw-obs
            v-if="
              selectedWarnType === 10 ||
                selectedWarnType === 11 ||
                selectedWarnType === 20
            "
          ></rw-obs>
          <rw-twn></rw-twn>
        </v-card>

        <rw-txt v-if="selectedRwDetailRwFlg"></rw-txt>
        <rw-number v-if="selectedRwDetailRwFlg"></rw-number>
      </v-row>
    </div>
  </div>
</template>

<script>
import Util from "./../../../lib/util.js";
import PageLog from "./../../../lib/pageLog.js";
import RwInfo from "../../../components/pc/RwInfo.vue";
import RwObs from "../../../components/pc/RwObs.vue";
import RwTwn from "../../../components/pc/RwTwn.vue";
import RwTxt from "../../../components/pc/RwTxt.vue";
import RwNumber from "../../../components/pc/RwNumber.vue";

export default {
  components: {
    RwInfo,
    RwObs,
    RwTwn,
    RwTxt,
    RwNumber,
  },
  data() {
    return {
      isDisp: false,
      text: {
        dispIu: "浸水想定を確認",
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[Riverwarn] mounted()");
    this.$store.commit("app/setContent", "Riverwarn");
    // ストアとクエリが異なる場合は、クエリを正としてストアを更新
    if (
      this.$store.state.RiverWarn.selectedWarnReq.cd !=
        this.$route.query["rwcd"] ||
      this.$store.state.RiverWarn.selectedWarnReq.type !=
        this.$route.query["rwtype"]
    ) {
      this.$store.commit("RiverWarn/setSelectedWarnReq", {
        cd: Number(this.$route.query["rwcd"]),
        type: Number(this.$route.query["rwtype"]),
      });
    }
    // 履歴モードの場合、選択中予警報を取得
    if (this.isCurrent === false) {
      this.$log.debug("[Riverwarn] mounted() - getSelectedRwDetail()");
      this.getSelectedRwDetail();
    }

    // 選択中浸水想定区域データがストアに設定済みであればプルダウンを更新
    if (
      this.$store.state.inundation.selectedInundationParam &&
      this.$store.state.inundation.selectedInundationParam.inundationId
    ) {
      this.selectedInundation = this.$store.state.inundation.selectedInundationParam;
      this.isDisp = true;
    }
  },
  beforeDestroy() {
    this.$store.commit("map/setSelectPointRiver", []);
  },
  computed: {
    /**
     * 表示時刻
     */
    appTimeRoundRw: {
      get() {
        return Util.formatDate(this.$store.state.app.appTimeRoundRw);
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTimeRoundRw: this.$store.state.app.appTimeRoundRw,
          selectedWarnType: this.$store.state.RiverWarn.selectedWarnReq.type,
          cd: this.$store.state.RiverWarn.selectedWarnReq.cd,
        };
      },
    },
    /**
     * 選択中予警報種別
     */
    selectedWarnType: {
      get() {
        return this.$store.state.RiverWarn.selectedWarnType;
      },
    },
    /**
     * 選択中河川予警報マスタ
     */
    selectedRwDetailMt: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.mt;
      },
    },
    /**
     * 選択中河川予警報詳細
     */
    selectedRwDetailRw: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rw[
          this.$store.state.RiverWarn.selectedAnnIdx
        ];
      },
    },
    /**
     * 観測日時
     */
    isCurrent: {
      get() {
        return this.$store.state.app.isCurrent;
      },
    },
    /**
     * 選択中河川予警報フラグ
     */
    selectedRwDetailRwFlg: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rwFlg;
      },
    },
    /**
     *  設定情報
     */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /**
     * 表示範囲の浸水想定区域データ
     */
    inundations: {
      get() {
        return {
          inundations: this.$store.state.inundation.inundations,
          selectedInundationParam: this.$store.state.inundation
            .selectedInundationParam,
        };
      },
    },
    /** 提供中の浸水想定一覧URL */
    inuListUrl: {
      get() {
        return this.$store.state.app.config.appConfig.linkUrls.inuListLink;
      },
    },
    dispIu: {
      get() {
        return this.isDisp;
      },
    },
    /** 選択中河川予警報データ */
    selectedRwDetail: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail;
      },
    },
    /** ズームレベル */
    zoom: {
      get() {
        return this.$store.state.map.zoom;
      },
    },
  },
  methods: {
    /**
     * 選択中予警報を取得
     */
    getSelectedRwDetail() {
      this.$log.debug("[Riverwarn] getSelectedRwDetail()");
      setTimeout(() => {
        this.$store.dispatch("RiverWarn/getSelectedRwDetail", {
          appTime: this.appTimeRoundRw,
          rwCd: this.reqParam.cd,
          type: this.reqParam.selectedWarnType,
        });
      }, 500);
    },
    /**
     * PDF表示ボタンクリック
     */
    openPdf(cd, type, annNo, annTime, docType, id) {
      this.$log.debug(
        "[Riverwarn] openPdf(" +
          cd +
          "," +
          type +
          "," +
          annNo +
          "," +
          annTime +
          "," +
          docType +
          "," +
          id +
          ")"
      );
      // アクセスログ出力
      let name = "";
      if (type == "fldfr") name = "fdfore_pdf";
      if (type == "evstg") name = "wlinfo_pdf";
      if (type == "fldctl") name = "fdcntl_pdf";
      if (type == "damdsch") name = "damdischa_pdf";
      PageLog.log({
        page_log: name,
        flood_cd: cd,
        flood_no: annNo,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      var url =
        this.$store.state.app.config.riverWarnConfig.pdfPath +
        type +
        "/" +
        cd +
        "_" +
        Util.formatDate(annTime, "YYYYMMDDHHmm") +
        "_" +
        annNo +
        "_" +
        docType +
        "_" +
        id +
        ".pdf";
      this.$log.debug("url:" + url);
      window.open(url, "_blank");
    },
    /** 河川予警報選択時の地図移動 */
    moveRw() {
      // 関連市町村の緯度経度を取得
      let nLat = 0;
      let eLon = 0;
      let sLat = 999;
      let wLon = 999;
      this.selectedRwDetail.mt.prefTwn.forEach((pref) => {
        pref.twn.forEach((twn) => {
          // 市町村情報を取得
          const target = this.$store.state.map.townLatLngList.find(
            (townInfo) => {
              return townInfo.twnCd == twn.twnCd;
            }
          );
          if (target) {
            // 最大と最小の緯度経度を設定
            if (target.maxLat > nLat) nLat = target.maxLat;
            if (target.maxLon > eLon) eLon = target.maxLon;
            if (target.minLat < sLat) sLat = target.minLat;
            if (target.minLon < wLon) wLon = target.minLon;
          }
        });
      });
      // 中心座標を設定
      let latLng = [];
      if (this.$store.state.RiverWarn.selectedWarnType == 30) {
        // ダム放流通知
        latLng = [this.selectedRwDetail.mt.lat, this.selectedRwDetail.mt.lon];
      } else {
        // 市町村座標の最大最小から中心を算出
        // 小数点計算の誤差を無くすため10*9倍にして計算する
        latLng = [
          (nLat * Math.pow(10, 9) + sLat * Math.pow(10, 9)) /
            2 /
            Math.pow(10, 9),
          (eLon * Math.pow(10, 9) + wLon * Math.pow(10, 9)) /
            2 /
            Math.pow(10, 9),
        ];
      }

      // 市町村座標を取得できていない場合は移動しない
      if (nLat != 0 && eLon != 0 && sLat != 999 && wLon != 999) {
        this.$store.commit("map/setMoveInfo", {
          zoom: this.$store.state.map.mapConfig.zoomInundation,
          center: latLng,
        });
      } else {
        this.$store.commit("map/setMoveInfo", {
          zoom: this.$store.state.map.mapConfig.zoomInundation,
          center: this.$store.state.map.center,
        });
      }
    },
  },
  watch: {
    /**
     * リクエストパラメータ変更時
     */
    reqParam() {
      this.$log.debug("[Riverwarn] watch(reqParam)");
      // リクエストパラメータ変更時には再取得
      this.getSelectedRwDetail();
    },
    inundations(val) {
      this.selectedInundation = val.selectedInundationParam;
    },
    dispIu() {
      if (this.isDisp) {
        if (this.selectedRwDetailMt.inundation) {
          setTimeout(() => {
            this.$store.commit(
              "inundation/setSelectedInundationParam",
              this.selectedRwDetailMt.inundation
            );
            this.moveRw();
          }, 100);
        }
      } else {
        setTimeout(() => {
          this.$store.commit("inundation/setSelectedInundationParam", {
            inundationId: null,
            inundationNm: "非表示",
          });
        }, 100);
      }
    },
    selectedRwDetailRw() {
      this.isDisp = false;
    },
    /** ズームレベル */
    zoom() {
      if (
        this.isDisp &&
        this.zoom <= this.$store.state.map.mapConfig.zoomInundation
      ) {
        setTimeout(() => {
          this.$store.commit(
            "inundation/setSelectedInundationParam",
            this.selectedRwDetailMt.inundation
          );
        }, 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rw-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  & * + * {
    margin-top: 16px;
  }

  .rw-box-card-list {
    // display: flex;
    flex: 1;
    position: relative;

    .rw-list {
      display: block;
      position: absolute;
      top: 0px;
      bottom: 0px;
      overflow-y: auto;
      overflow-x: hidden;
      width: 100%;
      .rw-info {
        width: 100%;

        .rw-header {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
.rw-tab-guide-tip {
  z-index: 3510;
}
.rw-status-legend {
  font-size: 10pt;
  font-weight: bold;
  display: inline-block;
  padding: 2px 4px 4px 2px;
  border-radius: 6px;
}
</style>
